module.exports = __webpack_public_path__ + "img/medical_bricks_1.999e9069.jpg";